import { RouteComponentProps } from "../../../../models/RouteComponent";
import useApiService from "../../../../hooks/useApiService";
import { DataTable } from "primereact/datatable";
import { EmergencyContactRecord } from "../../../../models/DSF/EmergencyContacts";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { CardActions, CardOverflow, Typography } from "@mui/joy";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

function EmergencyContact(props: RouteComponentProps) {
  const [expandedRows, setExpandedRows] = useState([]);
  const toast = useRef<any>(null);

  const { error, loading, data } = useApiService<EmergencyContactRecord[]>({
    method: "GET",
    url: "emergency-contacts",
    apiName: "core",
  });

  useEffect(() => {
    if (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Could not load emergency contacts",
      });
    }
  }, [error]);

  useEffect(() => {
    props.setGlobalLoader(loading);
  }, [loading]);

  const headerTemplate = (data: any) => {
    return (
      <>
        <span className="vertical-align-middle ml-2 font-bold line-height-3">{data.heading}</span>
      </>
    );
  };

  const footerTemplate = (data: any) => {
    return (
      <>
        <td colSpan={5}>
          <div className="flex justify-content-end font-bold w-full">
            Total {data.heading} emergency contacts: {calculateTotal(data.heading)}
          </div>
        </td>
      </>
    );
  };

  const calculateTotal = (heading: any) => {
    let total = 0;

    if (data) {
      for (let contacts of data) {
        if (contacts.heading === heading) {
          total++;
        }
      }
    }

    return total;
  };

  return (
    <>
      <Typography level="h2" component="h1">
        Emergency contacts
      </Typography>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15, marginBottom: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            name="button"
            icon="pi pi-save"
            label="Download PDF"
            className="p-button-outlined"
            size="small"
            disabled={true}
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => {}}
          />
        </CardActions>
      </CardOverflow>

      {data && (
        <div className={"card"}>
          <DataTable
            value={data}
            rowGroupMode="subheader"
            groupRowsBy="heading"
            sortMode="single"
            sortField="heading"
            sortOrder={1}
            expandableRowGroups
            expandedRows={expandedRows}
            onRowToggle={e => {
              // @ts-ignore
              setExpandedRows(e.data);
              // console.log("e", e);
            }}
            rowGroupHeaderTemplate={headerTemplate}
            rowGroupFooterTemplate={footerTemplate}
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column field={"title"} header={"Title"} style={{ width: "20%" }} />
            <Column field={"mobile"} header={"Phone"} style={{ width: "20%" }} />
            <Column field={"email"} header={"Email"} style={{ width: "20%" }} />
            <Column field={"active"} header={"Active"} style={{ width: "20%" }} />
            <Column field={"description"} header={"Description"} style={{ width: "20%" }} />
          </DataTable>
        </div>
      )}
      <Toast ref={toast} />
    </>
  );
}

export default EmergencyContact;
